export default __webpack_public_path__ + "static/O0099-8e4b956abbf664537776c744fc7a4ea7.png";